/**
 * Where a list was last left, so a record page's Back goes to the search that led to it
 * rather than to the top of a bare list.
 *
 * In `sessionStorage`, per tab: it survives a reload, a browser opening a row in a new
 * tab inherits a copy of it, and two tabs on the same list do not overwrite each other's
 * place. Every access is guarded - a browser set to block site data throws on read as
 * well as on write, and a list that cannot remember where it was is not a reason for the
 * page to fail.
 */
const KEY_PREFIX = "gantry-list-return:";

/** Remembers the query string this list is currently showing. */
export function rememberListSearch(path: string, search: string) {
  try {
    window.sessionStorage.setItem(`${KEY_PREFIX}${path}`, search);
  } catch {
    // Nothing to do: the next Back lands on the list with no search, as it used to.
  }
}

/**
 * The list path with whatever search it was last left at, or the bare path if nothing is
 * remembered - a record opened from a link of its own, say.
 */
export function listReturnPath(path: string) {
  try {
    return `${path}${window.sessionStorage.getItem(`${KEY_PREFIX}${path}`) ?? ""}`;
  } catch {
    return path;
  }
}
